import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { canAuthor } from '../../../helpers/userAuth';
import { selectCurrentUser } from '../../../selectors/authSelectors';

const AuthorViewLearning3kLab = ({ id, type }) => {
  const currentUser = useSelector(selectCurrentUser);
  const isAuthor = canAuthor(currentUser);

  if (!isAuthor || !id) {
    return null;
  }

  const handleClick = () => {
    const railsUrl = `/learning/${type}_preview/${id}`;
    window.open(railsUrl, '_blank');
  };

  return (
    <button className="lab-tools__l3k" onClick={handleClick}>
      L3k View
    </button>
  );
};

AuthorViewLearning3kLab.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['assignment', 'tutorial']).isRequired,
};

export default AuthorViewLearning3kLab;
